import { dynamicTabsActionTypes } from '.';
import { stronaPrzedmiotuActionTypes } from './stronaPrzedmiotu';
import { kartaPrzedmiotuActionTypes } from './kartaPrzedmiotu';
import { ActionTypes } from './interfaces';
import { RESET_REDUCERS } from '../auth/types';
import { isTabWithForm } from './helpers';
import { studentListWithMarksColumns } from '../../settings/tableColumns';
import cloneDeep from 'lodash.clonedeep';
const defaultTabKey = 'static_0';
const initState: DynamicTabsState = {
  tabList: [],
  incrementId: 0,
  activeTab: defaultTabKey,
};

export default function dynamicTabsReducer(state: DynamicTabsState = initState, action: ActionTypes): DynamicTabsState {
  let tempArray: Array<any> | null = null;
  let tempFind: any;
  let newActiveTabIndex: string;
  switch (action.type) {
    case dynamicTabsActionTypes.TAB_OPEN_NEW:
      tempFind = state.tabList.find(tab => tab.itemId === action.payload.itemId && tab.tabType === action.payload.tabType);
      if (tempFind) {
        if (tempFind.tabType === 'strona-przedmiotu') {
          const payloadStronaPrzedmiotu = action.payload as DynamicTabWithTable<any>;
          return {
            ...state,
            activeTab: action.tabsAmountOnInit ? action.tabsAmountOnInit.toString() : `${state.tabList.indexOf(tempFind)}`,
            tabList: state.tabList.map(tab =>
              tab.id === tempFind.id && !isTabWithForm(tab)
                ? {
                    ...tab,
                    table: {
                      ...tab.table,
                      search: payloadStronaPrzedmiotu.table.search,
                    },
                  }
                : tab,
            ),
          };
        }
        return {
          ...state,
          activeTab: action.tabsAmountOnInit ? action.tabsAmountOnInit.toString() : `${state.tabList.indexOf(tempFind)}`,
        };
      }
      return {
        ...state,
        tabList: [...state.tabList, { ...action.payload, id: state.incrementId.toString() }],
        activeTab: action.tabsAmountOnInit ? action.tabsAmountOnInit.toString() : `${state.tabList.length}`,
        incrementId: state.incrementId + 1,
      };
    case dynamicTabsActionTypes.TAB_CLOSE:
      tempArray = [...state.tabList];
      tempArray.splice(action.payload.index, 1);
      newActiveTabIndex = state.tabList[Number(action.payload.index) - 1]
        ? (Number(action.payload.index) - 1).toString()
        : 'static_0';
      return {
        ...state,
        tabList: tempArray.map((tab, index) =>
          index.toString() === newActiveTabIndex ? { ...tab, initTable: !tab.wasInitialized } : { ...tab },
        ),
        activeTab: newActiveTabIndex,
      };
    case dynamicTabsActionTypes.TABS_CLOSE_ALL:
      return {
        ...state,
        tabList: [],
      };
    case dynamicTabsActionTypes.TAB_SET_ACTIVE:
      return {
        ...state,
        activeTab: action.payload.activateKey,
        tabList: state.tabList.map((tab, index) =>
          index.toString() === action.payload.activateKey ? { ...tab, initTable: !tab.wasInitialized } : tab,
        ),
      };
    case dynamicTabsActionTypes.INIT:
      return {
        ...state,
        tabList: state.tabList.map(tab =>
          tab.id === action.payload.tabId
            ? isTabWithForm(tab)
              ? {
                  ...tab,
                  leftPanel: { ...tab.leftPanel, loading: true },
                  form: { ...tab.form, loading: true },
                }
              : {
                  ...tab,
                  leftPanel: { ...tab.leftPanel, loading: true },
                  table: { ...tab.table, initTable: !tab.wasInitialized, loading: true },
                }
            : tab,
        ),
      };
    case dynamicTabsActionTypes.INIT_FINISH:
      return {
        ...state,
        tabList: state.tabList.map(tab =>
          tab.id === action.payload.tabId ? { ...tab, initTable: false, wasInitialized: true } : tab,
        ),
      };
    case dynamicTabsActionTypes.INIT_TABLE_FINISH:
      return {
        ...state,
        tabList: state.tabList.map(tab =>
          tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                table: {
                  ...tab.table,
                  initTable: false,
                  loading: false,
                },
              }
            : tab,
        ),
      };
    case dynamicTabsActionTypes.COLUMNS_GET_CONFIG_SUCCESS:
      return {
        ...state,
        tabList: state.tabList.map(tab =>
          tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                table: {
                  ...tab.table,
                  columns: action.payload.mainColumns,
                  marksColumns: action.payload.marksColumns ? action.payload.marksColumns : [],
                },
              }
            : tab,
        ),
      };
    case dynamicTabsActionTypes.COLUMNS_GET_CONFIG_FAIL:
      return {
        ...state,
        tabList: state.tabList.map(tab =>
          tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                table: {
                  ...tab.table,
                  loading: false,
                  error: true,
                },
              }
            : tab,
        ),
      };
    case dynamicTabsActionTypes.COLUMNS_CHANGE_SORTING: {
      const tab = state.tabList.find(tab => tab.id === action.payload.tabId && !isTabWithForm(tab)) as DynamicTabWithTable<any>;
      const columns = tab.table.columns;
      columns.forEach(element => {
        if (element.dataIndex === action.payload.sortingInfo.dataIndex && action.payload.sortingInfo.sortOrder) {
          element.sortOrder = action.payload.sortingInfo.sortOrder;
        } else delete element.sortOrder;
      });
      return {
        ...state,
        tabList: state.tabList.map(tab =>
          tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                studentWithMarksData: {
                  data: tab.studentWithMarksData?.data ? tab.studentWithMarksData.data : [],
                  loading: false,
                  columns: studentListWithMarksColumns,
                  sorting: {
                    columnName: action.payload.sortingInfo.dataIndex,
                    order: action.payload.sortingInfo.sortOrder,
                  },
                },
                table: {
                  ...tab.table,
                  columns: columns,
                  sorting: {
                    columnName: action.payload.sortingInfo.dataIndex,
                    order: action.payload.sortingInfo.sortOrder,
                  },
                },
              }
            : tab,
        ),
      };
    }
    case dynamicTabsActionTypes.COLUMNS_SAVE_USER_SETUP_SUCCESS:
      return {
        ...state,
        tabList: state.tabList.map(tab =>
          tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                table: {
                  ...tab.table,
                  userColumnsSetup: {
                    ...tab.table.userColumnsSetup,
                    main: action.payload.data
                      .map(column => (column.inMain ? column.dataIndex : null))
                      .filter((column): column is string => !!column),
                    details: action.payload.data
                      .map(column => (column.inDetails ? column.dataIndex : null))
                      .filter((column): column is string => !!column),
                  },
                },
              }
            : tab,
        ),
      };
    //verify
    case dynamicTabsActionTypes.SET_LEFT_PANEL_LOADING:
    case kartaPrzedmiotuActionTypes.FETCH_CARD_DATA_START:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId
            ? {
                ...tab,
                noAccess: false,
                leftPanel: {
                  ...tab.leftPanel,
                  loading: !tab.leftPanel.loading,
                },
              }
            : tab;
        }),
      };
    case dynamicTabsActionTypes.GET_LEFT_PANEL_DATA_SUCCESS:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId
            ? {
                ...tab,
                titleTranslationKey: action.payload.titleTranslationKey,
                noAccess: false,
                leftPanel: {
                  ...tab.leftPanel,
                  loading: false,
                  data: action.payload.data,
                },
              }
            : tab;
        }),
      };
    case dynamicTabsActionTypes.GET_LEFT_PANEL_DATA_FAIL:
    case kartaPrzedmiotuActionTypes.FETCH_CARD_DATA_FAIL:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId
            ? {
                ...tab,
                noAccess: true,
                leftPanel: { ...tab.leftPanel, loading: false, error: true },
              }
            : tab;
        }),
      };
    case dynamicTabsActionTypes.SET_LOADING:
    case stronaPrzedmiotuActionTypes.GET_DATA_START:
      // todo: do uzupelnienia kolejne akcje z zakladek
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                table: {
                  ...tab.table,
                  loading: true,
                  cache: {
                    ...tab.table.cache,
                    syncInProgress: true,
                    error: false,
                  },
                },
              }
            : tab;
        }),
      };
    case stronaPrzedmiotuActionTypes.GET_DATA_STUDENT_LIST_WITH_MARKS_START:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                studentWithMarksData: {
                  data: [],
                  loading: true,
                  columns: studentListWithMarksColumns,
                  sorting: {
                    columnName: tab.studentWithMarksData?.sorting?.columnName,
                    order: tab.studentWithMarksData?.sorting?.order,
                  },
                },
              }
            : tab;
        }),
      };
    case stronaPrzedmiotuActionTypes.GET_DATA_STUDENT_LIST_WITH_MARKS_SUCCESS: {
      const columns = cloneDeep(studentListWithMarksColumns);
      columns.forEach((column: any) => {
        if (column.children) {
          action.payload.data.data[0].oceny.forEach((mark: any, index: any) => {
            column.children.push({
              title: `${mark.formaNazwa.charAt(0).toUpperCase()}${mark.formaNazwa.slice(1)} (${
                mark.formaWaga ? mark.formaWaga : 0
              }%)`,
              type: 'text',
              align: 'center',
              render: (value: any) => value.oceny[index].ocena,
            });
          });
        }
      });
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                studentWithMarksData: {
                  data: action.payload.data.data,
                  loading: false,
                  columns: columns,
                  sorting: {
                    columnName: tab.studentWithMarksData?.sorting?.columnName,
                    order: tab.studentWithMarksData?.sorting?.order,
                  },
                },
              }
            : tab;
        }),
      };
    }
    case stronaPrzedmiotuActionTypes.GET_DATA_STUDENT_LIST_WITH_MARKS_CANCEL:
    case stronaPrzedmiotuActionTypes.GET_DATA_STUDENT_LIST_WITH_MARKS_FAIL:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                studentWithMarksData: {
                  data: [],
                  loading: false,
                  columns: studentListWithMarksColumns,
                  sorting: {
                    columnName: tab.studentWithMarksData?.sorting?.columnName,
                    order: tab.studentWithMarksData?.sorting?.order,
                  },
                },
              }
            : tab;
        }),
      };
    case dynamicTabsActionTypes.SET_SEARCH:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                table: {
                  ...tab.table,
                  search: action.payload.search,
                },
              }
            : tab;
        }),
      };
    case dynamicTabsActionTypes.SET_PAGE:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                table: {
                  ...tab.table,
                  page: action.payload.page,
                },
              }
            : tab;
        }),
      };
    case dynamicTabsActionTypes.SET_ORDER:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                table: {
                  ...tab.table,
                  sorting: {
                    columnName: action.payload.settings.columnName,
                    order: action.payload.settings.order,
                  },
                },
              }
            : tab;
        }),
      };
    case dynamicTabsActionTypes.SET_SELECTED:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                table: {
                  ...tab.table,
                  selected: action.payload.selected,
                },
              }
            : tab;
        }),
      };
    case dynamicTabsActionTypes.SET_EXPANDED:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                table: {
                  ...tab.table,
                  expanded: action.payload.expanded,
                },
              }
            : tab;
        }),
      };
    case dynamicTabsActionTypes.SET_DETAILS_LOADING:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                table: {
                  ...tab.table,
                  loadingDetails: !tab.table.loadingDetails,
                },
              }
            : tab;
        }),
      };
    case dynamicTabsActionTypes.SET_DATA_AFTER_SORT:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                table: {
                  ...tab.table,
                  data: action.payload.data,
                },
              }
            : tab;
        }),
      };
    case dynamicTabsActionTypes.SET_DATA_ATTENDANCE_LIST_AFTER_SORT:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                table: {
                  ...tab.table,
                  dataAttendanceList: action.payload.data,
                },
              }
            : tab;
        }),
      };
    case dynamicTabsActionTypes.GET_DATA_FAIL:
      return {
        ...state,
        // noAccess: Number(action.payload.error) === codes.RESOURCE_ACCESS_ERROR ||
        // Number(action.payload.error) === codes.RESOURCE_NOT_EXIST_ERROR ? true : null,
        tabList: state.tabList.map(tab =>
          tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                table: {
                  ...tab.table,
                  error: true,
                  loading: false,
                  cache: {
                    ...tab.table.cache,
                    syncInProgress: false,
                    error: true,
                  },
                },
              }
            : tab,
        ),
      };
    case dynamicTabsActionTypes.GET_DATA_SUCCESS:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                noAccess: false,
                table: {
                  ...tab.table,
                  data: action.payload.data.data,
                  dataAttendanceList: action.payload.data.data,
                  error: false,
                  loading: false,
                  totalPage: action.payload.data.totalPages,
                  totalRecords: action.payload.data.totalRecords,
                  page: action.payload.data.page,
                  cache: {
                    ...tab.table.cache,
                    syncInProgress: false,
                    controlSum: action.payload.data.controlSum ? action.payload.data.controlSum : '',
                    duration: action.payload.data.cacheDuration ? action.payload.data.cacheDuration : 0,
                  },
                },
              }
            : tab;
        }),
      };
    case dynamicTabsActionTypes.FILTERS_GET_CONFIG_SUCCESS:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                table: {
                  ...tab.table,
                  filters: {
                    ...tab.table.filters,
                    loading: false,
                    error: false,
                    allFilters: action.payload.data.map(filter => ({
                      ...filter,
                      active: filter.isDefault,
                      error: false,
                      loading: false,
                      selected: filter.defaultValue ? [filter.defaultValue] : [],
                      selectedValues: [],
                      values: [],
                    })),
                  },
                },
              }
            : tab;
        }),
      };
    case dynamicTabsActionTypes.FILTERS_GET_CONFIG_FAIL:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                table: {
                  ...tab.table,
                  filters: {
                    ...tab.table.filters,
                    isInitialized: false,
                    loading: false,
                    error: true,
                  },
                },
              }
            : tab;
        }),
      };
    case dynamicTabsActionTypes.FILTERS_OPEN_CATEGORY:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                table: {
                  ...tab.table,
                  filters: {
                    ...tab.table.filters,
                    allFilters: tab.table.filters.allFilters.map(filter => {
                      return action.payload.filtersGroups.find(filterGroup => filterGroup === filter.name)
                        ? { ...filter, active: true }
                        : { ...filter, active: false, selected: [], selectedValues: [] };
                    }),
                  },
                },
              }
            : tab;
        }),
      };
    case dynamicTabsActionTypes.FILTERS_CLOSE_CATEGORY:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                table: {
                  ...tab.table,
                  filters: {
                    ...tab.table.filters,
                    allFilters: tab.table.filters.allFilters.map(filter =>
                      filter.name === action.payload.filter
                        ? {
                            ...filter,
                            active: false,
                            selected: [],
                            selectedValues: [],
                          }
                        : filter,
                    ),
                  },
                },
              }
            : tab;
        }),
      };
    case dynamicTabsActionTypes.FILTERS_SELECT_VALUES:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                table: {
                  ...tab.table,
                  filters: {
                    ...tab.table.filters,
                    allFilters: tab.table.filters.allFilters.map(filter =>
                      filter.name === action.payload.filters.filterGroupName
                        ? {
                            ...filter,
                            selected: action.payload.filters.filterValues,
                            selectedValues: filter.values
                              .map(singleValue =>
                                action.payload.filters.filterValues.includes(singleValue.value) ? singleValue.nazwa : null,
                              )
                              .filter(singleValue => singleValue !== null),
                          }
                        : filter,
                    ),
                  },
                },
              }
            : tab;
        }),
      };
    //todo: dodaj case dla pozostalych zakladek
    case stronaPrzedmiotuActionTypes.FILTERS_REFRESH_VALUES_START:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                table: {
                  ...tab.table,
                  filters: {
                    ...tab.table.filters,
                    loading: false,
                    allFilters: tab.table.filters.allFilters.map(filter => ({
                      ...filter,
                      loading: filter.active,
                      error: false,
                    })),
                  },
                },
              }
            : tab;
        }),
      };
    case dynamicTabsActionTypes.FILTERS_REFRESH_VALUES_SUCCESS:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                table: {
                  ...tab.table,
                  filters: {
                    ...tab.table.filters,
                    isInitialized: true,
                    loading: false,
                    allFilters: tab.table.filters.allFilters.map(filter => {
                      let newValues: any[] = [];
                      Object.keys(action.payload.data).forEach(key => {
                        if (key === filter.name) {
                          newValues = action.payload.data[key];
                        }
                      });
                      return {
                        ...filter,
                        values: newValues,
                        loading: false,
                        error: false,
                      };
                    }),
                  },
                },
              }
            : tab;
        }),
      };
    case dynamicTabsActionTypes.FILTERS_REFRESH_VALUES_FAIL:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                table: {
                  ...tab.table,
                  filters: {
                    ...tab.table.filters,
                    isInitialized: false,
                    loading: false,
                    allFilters: tab.table.filters.allFilters.map(filter => ({
                      ...filter,
                      loading: false,
                      error: true,
                    })),
                  },
                },
              }
            : tab;
        }),
      };
    case dynamicTabsActionTypes.RECORD_GET_DETAILS_START:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                table: {
                  ...tab.table,
                  loadingDetails: true,
                  errorDetails: false,
                },
              }
            : tab;
        }),
      };
    // verify sprawdzic poprawnoc reducera w zakladce strona-studenta, ew wyczyscic, ujednolicić również w komponentach ocen
    case dynamicTabsActionTypes.RECORD_GET_DETAILS_SUCCESS:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                table: {
                  ...tab.table,
                  loadingDetails: false,
                  errorDetails: false,
                  data: tab.table.data.map(row =>
                    row.key === action.payload.recordId
                      ? {
                          ...row,
                          details: action.payload.data,
                          marks: {
                            ...action.payload.marksData,
                            ocenaKoncowa: action.payload.marksData.ocenaKoncowa,
                            ocenaWyliczona: action.payload.marksData.ocenaWyliczona,
                            formyZajec: action.payload.marksData.formyZajec
                              ? action.payload.marksData.formyZajec.formy
                              : undefined,
                            oceny: action.payload.marksData.oceny,
                          },
                          dostep: action.payload.marksData.formyZajec,
                        }
                      : row,
                  ),
                },
              }
            : tab;
        }),
      };
    case dynamicTabsActionTypes.RECORD_GET_DETAILS_FAIL:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                table: {
                  ...tab.table,
                  loadingDetails: false,
                  errorDetails: true,
                },
              }
            : tab;
        }),
      };
    case dynamicTabsActionTypes.REFRESH_SELECTED_DATA_SUCCESS:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                table: {
                  ...tab.table,
                  data: tab.table.data.map((row: any) => {
                    if (action.payload.recordsToRefresh.includes(row.studentId)) {
                      const newData = action.payload.data.find((record: any) => record.studentId === row.studentId);
                      return {
                        ...newData,
                        key: row.studentId,
                        details: row.details,
                        marks: row.marks,
                        dostep: row.dostep,
                      };
                    } else return row;
                  }),
                },
              }
            : tab;
        }),
      };
    case dynamicTabsActionTypes.SYNC_DATA_WITH_CACHE_START:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                table: {
                  ...tab.table,
                  cache: {
                    ...tab.table.cache,
                    syncInProgress: true,
                    error: false,
                  },
                },
              }
            : tab;
        }),
      };
    case dynamicTabsActionTypes.SYNC_DATA_WITH_CACHE_SUCCESS:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                table: {
                  ...tab.table,
                  cache: {
                    ...tab.table.cache,
                    syncInProgress: false,
                    controlSum: action.payload.data.controlSum,
                    isUpToDate: action.payload.data.isUpToDate,
                    duration: action.payload.data.duration,
                  },
                },
              }
            : tab;
        }),
      };
    case dynamicTabsActionTypes.SYNC_DATA_WITH_CACHE_FAIL:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && !isTabWithForm(tab)
            ? {
                ...tab,
                table: {
                  ...tab.table,
                  cache: {
                    ...tab.table.cache,
                    syncInProgress: false,
                    error: true,
                  },
                },
              }
            : tab;
        }),
      };
    case kartaPrzedmiotuActionTypes.FORM_TEMPLATE_GET_START:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && isTabWithForm(tab)
            ? {
                ...tab,
                form: {
                  ...tab.form,
                  loadingTemplate: true,
                },
              }
            : tab;
        }),
      };
    case kartaPrzedmiotuActionTypes.FORM_TEMPLATE_GET_SUCCESS:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && isTabWithForm(tab)
            ? {
                ...tab,
                form: {
                  ...tab.form,
                  formTemplates: action.payload.data.filter((element: any) => element.dataIndex !== 'dataAktualizacji'), // dataAktualizacji comes from DB and no uses for it
                  loadingTemplate: false,
                  error: false,
                },
              }
            : tab;
        }),
      };
    case kartaPrzedmiotuActionTypes.FORM_TEMPLATE_GET_FAIL:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && isTabWithForm(tab)
            ? {
                ...tab,
                form: {
                  ...tab.form,
                  loadingTemplate: false,
                  error: true,
                },
              }
            : tab;
        }),
      };
    case kartaPrzedmiotuActionTypes.FORM_DATA_GET_START:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && isTabWithForm(tab)
            ? {
                ...tab,
                form: {
                  ...tab.form,
                  loadingValues: true,
                },
              }
            : tab;
        }),
      };
    case kartaPrzedmiotuActionTypes.FORM_DATA_GET_SUCCESS:
      const correctFormValues = action.payload.data.data.filter((element: any) => element.dataIndex !== 'dataAktualizacji'); // dataAktualizacji comes from DB and no uses for it
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && isTabWithForm(tab)
            ? {
                ...tab,
                form: {
                  ...tab.form,
                  loadingValues: false,
                  error: false,
                  inEdition: action.payload.data.czyWEdycji ? Boolean(action.payload.data.czyWEdycji) : false,
                  isPossibleSaveInSID: {
                    status: action.payload.data.moznaEdytowac ? Boolean(action.payload.data.moznaEdytowac.wynik) : false,
                    message: action.payload.data.moznaEdytowac?.komunikat,
                  },
                  formValues: correctFormValues,
                  originFormValues: correctFormValues,
                },
              }
            : tab;
        }),
      };
    case kartaPrzedmiotuActionTypes.FORM_DATA_GET_FAIL:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && isTabWithForm(tab)
            ? {
                ...tab,
                form: {
                  ...tab.form,
                  loadingValues: false,
                  error: true,
                },
              }
            : tab;
        }),
      };
    case kartaPrzedmiotuActionTypes.GET_CARD_FROM_SID_START:
    case kartaPrzedmiotuActionTypes.FORM_DATA_SAVE_START:
    case kartaPrzedmiotuActionTypes.INIT_PUBLISHING:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && isTabWithForm(tab)
            ? {
                ...tab,
                form: {
                  ...tab.form,
                  loadingValues: true,
                  loadingTemplate: true,
                },
              }
            : tab;
        }),
      };
    case kartaPrzedmiotuActionTypes.GET_CARD_FROM_SID_SUCCESS:
    case kartaPrzedmiotuActionTypes.FORM_DATA_SAVE_SUCCESS:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && isTabWithForm(tab)
            ? {
                ...tab,
                form: {
                  ...tab.form,
                  loadingValues: false,
                  loadingTemplate: false,
                  readOnly: action.payload.readOnly !== undefined ? action.payload.readOnly : true,
                },
              }
            : tab;
        }),
      };
    case kartaPrzedmiotuActionTypes.GET_CARD_FROM_SID_FAIL:
    case kartaPrzedmiotuActionTypes.FORM_DATA_SAVE_FAIL:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && isTabWithForm(tab)
            ? {
                ...tab,
                form: {
                  ...tab.form,
                  loadingValues: false,
                  loadingTemplate: false,
                  error: true,
                },
              }
            : tab;
        }),
      };
    case kartaPrzedmiotuActionTypes.FORM_TEMPLATE_SET_VERSION:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && isTabWithForm(tab)
            ? {
                ...tab,
                form: {
                  ...tab.form,
                  templateVersion: action.payload.wersjaSzablonuKarty,
                },
              }
            : tab;
        }),
      };
    case kartaPrzedmiotuActionTypes.FORM_TOGGLE_EDIT_MODE:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && isTabWithForm(tab)
            ? {
                ...tab,
                form: {
                  ...tab.form,
                  readOnly: !tab.form.readOnly,
                  formValues: tab.form.originFormValues,
                },
              }
            : tab;
        }),
      };
    case kartaPrzedmiotuActionTypes.FORM_DATA_UPDATE:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && isTabWithForm(tab)
            ? {
                ...tab,
                form: {
                  ...tab.form,
                  formValues: tab.form.formValues.map((element, idx) =>
                    element.dataIndex === action.payload.dataIndex ? { ...element, data: action.payload.data } : element,
                  ),
                },
              }
            : tab;
        }),
      };
    case kartaPrzedmiotuActionTypes.FORM_RESET_DATA:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && isTabWithForm(tab)
            ? {
                ...tab,
                form: {
                  ...tab.form,
                  formValues: tab.form.formValues,
                },
              }
            : tab;
        }),
      };
    case kartaPrzedmiotuActionTypes.KARTA_SAVE_TEMPORARILY_IN_SID_START:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && isTabWithForm(tab)
            ? {
                ...tab,
                form: {
                  ...tab.form,
                  loadingTemplate: true,
                },
              }
            : tab;
        }),
      };
    case kartaPrzedmiotuActionTypes.KARTA_SAVE_TEMPORARILY_IN_SID_FAIL:
      return {
        ...state,
        tabList: state.tabList.map(tab => {
          return tab.id === action.payload.tabId && isTabWithForm(tab)
            ? {
                ...tab,
                form: {
                  ...tab.form,
                  loadingTemplate: false,
                },
              }
            : tab;
        }),
      };
    case RESET_REDUCERS:
      // reset danych stora
      return {
        ...initState,
      };
    default:
      return state;
  }
}
